import React from "react";
import { AnimatedHeight } from "./animatedHeight";
import { extractAnimatedHeightProps } from "./util";

const combineStyles = (divStyle, style) => {
  return {...divStyle, ...style};
};

const combineInnerProps = (innerProps, combinedStyles) => {
  return {...innerProps, style: combinedStyles};
};

const AnimatedToggleDefaultProps  = { 
  element: "div"
};

export const _AnimatedToggle = (props) => {
  const {innerProps, show, ...otherProps } = extractAnimatedHeightProps(props);
  const divStyle = {height: show ? "auto" : "0px"};
  const { style: innerStyle = {} } = innerProps || {};

  const combinedStyles = combineStyles(divStyle, innerStyle);
  return (
    <AnimatedHeight
      innerProps={combineInnerProps(innerProps, combinedStyles)}
      {...otherProps}
    />
  );
};

export const AnimatedToggle = (props) => (<_AnimatedToggle {...AnimatedToggleDefaultProps} {...props} />);
// AnimatedToggle.defaultProps = {
//   element: "div"
// };